import React from 'react';



const ScreenStatic = () => {

    const styles = {

        pageContainer: {

            width: '100%',

            minHeight: '100vh',

            display: 'flex',

            justifyContent: 'center',

            backgroundColor: '#f5f5f5'

        },

        container: {

            maxWidth: '800px',

            margin: '40px auto',

            padding: '40px',

            backgroundColor: '#ffffff',

            borderRadius: '8px',

            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

            fontFamily: 'Arial, sans-serif'

        },

        header: {

            display: 'flex',

            justifyContent: 'space-between',

            alignItems: 'center',

            marginBottom: '30px'

        },

        title: {

            fontSize: '28px',

            color: '#00234B',

            marginBottom: '30px',

            textAlign: 'center'

        },

        mainText: {

            fontSize: '16px',

            color: '#00234B',

            lineHeight: '1.6',

            marginBottom: '30px',

            textAlign: 'left'

        },

        stepsList: {

            listStyle: 'none',

            padding: '0 20px',

            marginBottom: '40px'

        },

        stepItem: {

            marginBottom: '15px',

            fontSize: '16px',

            color: '#00234B',

            textAlign: 'left'

        },

        email: {

            color: '#0066CC',

            textDecoration: 'none'

        },

        subheading: {

            fontSize: '18px',

            color: '#00234B',

            marginBottom: '20px',

            fontWeight: 'bold',

            textAlign: 'left'

        },

        staticHeader: {

            padding: '15px',

            borderBottom: '1px solid #eee',

            display: 'flex',

            justifyContent: 'space-between',

            alignItems: 'center'

        },

        pageTitle: {

            margin: 0,

            fontSize: '20px'

        },

        iconGroup: {

            display: 'flex',

            gap: '15px'

        }

    };



    return (

        <div style={styles.pageContainer}>

            <div style={styles.container}>

                <div style={styles.staticHeader}>

                    {/* <h1 style={styles.pageTitle}>Static Page</h1> */}

                    {/* <div style={styles.iconGroup}>

                        <span>🔍</span>

                        <span>🔔</span>

                        <span>⚙️</span>

                        <span>DB</span>

                    </div> */}

                </div>



                <h1 style={styles.title}>Request Account Deletion</h1>



                <p style={styles.mainText}>

                    At Beauti, we take our obligations under the various data protection and privacy legislation very seriously. If you wish to have your account on our website or mobile application permanently deleted, please follow the steps outlined below:

                </p>



                <ul style={styles.stepsList}>

                    <li style={styles.stepItem}>

                        STEP1: Email your request to <a href="mailto:support@beautisoftware.com" style={styles.email}>support@beautisoftware.com</a>

                    </li>

                    <li style={styles.stepItem}>

                        STEP2: We will confirm your wish to proceed with your deletion request, by return email

                    </li>

                    <li style={styles.stepItem}>

                        STEP3: Having then received your confirmation, we will proceed to complete the deletion and then notify you that your Contact record and Account have been permanently erased from our records

                    </li>

                </ul>



                <h2 style={styles.subheading}>Rights of Access to Information and the Right To Erasure (Rights To Be Forgotten)</h2>



                <p style={styles.mainText}>

                    Under the latest European Data Protection Legislation (GDPR) you the right to access information held about you. Your right of access can be exercised in accordance with this Act.

                </p>



                <p style={styles.mainText}>

                    We only hold your data for as long as is necessary or for as long as you have proactively opted for us to do so. We have an audit facility in our systems to determine how recently your data has been updated or used and we use that facility to determine if your data should be modified or removed.

                </p>

            </div>

        </div>

    );

};



export default ScreenStatic;

